import ContextProvider from 'common/contexts/crud';
import React, { createContext, useContext } from 'react';

const TodosContext = createContext();
const useTodos = () => useContext(TodosContext);

export const TodosProvider = (props) => <ContextProvider url="todos" context={TodosContext} {...props} />;

export default useTodos;
